export const GET_TICKET_MANAGEMENT_LIST = null;
export const SELECTED_TICKET_MANAGEMENT_ID = null;
export const SELECTED_TICKET_MANAGEMENT_CHAT_ID_DETAILS = null;